import React from "react";
import styles from "./ExpiredNotice.module.css";

//Notice for return links that are no longer valid
const ExpiredNotice = ({ font, linkType }) => (
  <div className={`${font} ${styles.expired_notice}`}>
    <h2 className={styles.expired_title}>{linkType} link has expired.</h2>
    <p className={styles.expired_message}>This order is no longer eligible for {linkType}.</p>
  </div>
);

export default ExpiredNotice;